import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { purple, red } from '@material-ui/core/colors';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { CommentsMenu } from '../CommentsMenu';
import { createRef, useRef, useState } from 'react';
import { Comment } from '../../../../domain/models/Comment';
import { useStyles } from '../styles';

export const CommentCart = ({ content, created, creator }: Comment) => {
  const classes = useStyles();
  const [openMenuActions, setOpenMenuActions] = useState<any>(null);
  const refMenuAction = createRef<any>();
  return (
    <Card variant='outlined' className={classes.cardbox}>
      <CardHeader
        avatar={
          <Avatar style={{ backgroundColor: purple[200] }} aria-label='recipe'>
            {creator.name[0].toUpperCase()}
          </Avatar>
        }
        action={
          <div ref={refMenuAction}>
            <IconButton
              aria-label='settings'
              onClick={(e) => setOpenMenuActions(e.target)}
            >
              <MoreVertIcon />
            </IconButton>
          </div>
        }
        title={creator.name}
        subheader={created}
      />
      <CardContent>
        <Typography variant='body2' color='textPrimary'>
          {content}
        </Typography>
      </CardContent>
    </Card>
  );
};
